module.exports = __webpack_public_path__ + "img/PRCA2_pDC.7711899c.png";